/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Advantages_Sample_Ref_1Inputs */

const en_advantages_sample_ref_1 = /** @type {(inputs: Advantages_Sample_Ref_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`[1] This formulation helps when we move to more complex domains like the Open Images Dataset`)
};

const es_advantages_sample_ref_1 = /** @type {(inputs: Advantages_Sample_Ref_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`[1] Esta formulación ayuda cuando nos movemos a dominios más complejos como el conjunto de datos Open Images`)
};

/**
* | output |
* | --- |
* | "[1] This formulation helps when we move to more complex domains like the Open Images Dataset" |
*
* @param {Advantages_Sample_Ref_1Inputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const advantages_sample_ref_1 = /** @type {((inputs?: Advantages_Sample_Ref_1Inputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Advantages_Sample_Ref_1Inputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_advantages_sample_ref_1(inputs)
	return en_advantages_sample_ref_1(inputs)
});